import { gql } from '@apollo/client';
import { STAFF_DETAIL_FIELDS } from '../../fragments';
import { StaffType } from '../../../types';
import { ApolloClientFunctionProps } from '../../utils';
import { GetStaffByIdProps, GetStaffByUidProps } from './staff.types';

export const GET_STAFF = gql`
  ${STAFF_DETAIL_FIELDS}
  query GetStaffList {
    staffList {
      ...StaffDetailFields
    }
  }
`;

/**
 * Get Staff Function
 *
 * @param param0 client: ApolloClient<NormalizedCacheObject>
 * @returns StaffType[]
 */
export function getStaff({ client }: ApolloClientFunctionProps) {
  return client?.watchQuery<{ staffList: StaffType[] }>({
    query: GET_STAFF,
  });
}

export const GET_STAFF_BY_ID = gql`
  ${STAFF_DETAIL_FIELDS}
  query GetStaffById($staffId: ID!) {
    staff(staffId: $staffId) {
      ...StaffDetailFields
    }
  }
`;

/**
 * Get Staff By Id Function
 *
 * @param param0 client: ApolloClient<NormalizedCacheObject>
 * @param param1 staffId: String
 * @returns StaffType
 */
export function getStaffById({ client, staffId }: GetStaffByIdProps) {
  return client?.watchQuery<{ staff: StaffType }>({
    query: GET_STAFF_BY_ID,
    variables: {
      staffId,
    },
  });
}

export const GET_STAFF_BY_UID = gql`
  ${STAFF_DETAIL_FIELDS}
  query GetStaffByUid($uid: ID!) {
    staffByUid(uid: $uid){
      ...StaffDetailFields
    }
  }
`;

export function getStaffByUid({ client, uid }: GetStaffByUidProps) {
  return client?.watchQuery<{ staffByUid: StaffType }>({
    query: GET_STAFF_BY_UID,
    variables: {
      uid,
    },
  });
}
